// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"214":"b17f6c1d","838":"b17f6c1d"}[chunkId] + ".chunk.css";
};